// A custom theme for this app
import { createTheme } from '@mui/material';

const theme = createTheme({
  cssVariables: true,
  components: {
    MuiAlert: {
      styleOverrides: {
        filledWarning: {
          color: '#fff',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          fontFamily: "'Twemoji', 'Exo 2', sans-serif",
        },
      },
    },
  },
  palette: {
    chartSeries: ['#3B82F6', '#84CC16', '#10B981', '#06B6D4', '#6366F1', '#D84444', '#CA901B', '#F59E0B'],
    warning: {
      light: '#ffb300',
      main: '#eb9d00',
      dark: '#c28200',
      contrastText: '#fff',
    },
    primary: {
      light: '#00568f',
      main: '#00375c',
      dark: '#002b47',
      contrastText: '#fff',
    },
    secondary: {
      light: '#f19346',
      main: '#ed7616',
      dark: '#df6e11',
      contrastText: '#fff',
    },
  },
  typography: {
    h1: { fontWeight: 400, letterSpacing: '-1.75px' },
    h2: { fontWeight: 500, letterSpacing: '-0.75px' },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600, letterSpacing: '0px' },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600, letterSpacing: '0px' },
    subtitle1: { fontWeight: 600, letterSpacing: '0px' },
    subtitle2: { fontWeight: 700, letterSpacing: '0px' },
    body1: { letterSpacing: '0.15px' },
    body2: { letterSpacing: '0px' },
    button: { letterSpacing: '0.5px' },
    caption: { letterSpacing: '-0.25px' },
    overline: { fontSize: '11px', fontWeight: 500, letterSpacing: '1px' },
    helperText: {
      fontWeight: 400,
      fontSize: '12px',
      letterSpacing: '0.15px',
    },
    stateText: {
      fontWeight: 500,
      fontSize: '16px',
      fontStyle: 'italic',
      letterSpacing: '0.15px',
    },
    allVariants: {
      fontFamily: "'Twemoji', 'Exo 2', sans-serif",
    },
  },
  zIndex: {
    globalError: 10000,
  },
});

export default theme;
